import React from 'react';
import { FormattedMessage, intlShape, injectIntl } from 'react-intl';
import randomstring from 'uuid/v4';

import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import Switch from '@material-ui/core/Switch';

class Filter extends React.Component {

    state = {
        all: this.props.shownlocals,
        hide: this.props.hide
    }

    handleClose = (hide) => (event) => {
        this.props.onClose(hide);
    }

    handleChecked = (id) => (event) => {
        const { hide } = this.state;
        const arr = [...hide];
        const index = hide.indexOf(id);
        if(index < 0){
            arr.push(id);
        } else {
            arr.splice(index, 1);
        }
        this.setState({ hide: arr });
    }

    render() {
        const { all, hide } = this.state;
        return (
            <Dialog
                open={true}
                onClose={this.handleClose([])}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogContent className={'padding_borders'}>
                    <div className="barlow_medium_tree_local flex_full_row margin_top_12 margin_bottom_24 c_dark_grey_blue">
                        <FormattedMessage id="manage_local_menu" />
                    </div>
                    {all.map((l) =>
                        <div key={randomstring()} className="flex_full_row margin_top_12 align_center">
                            <Switch
                                checked={hide.indexOf(l.local) < 0}
                                onChange={this.handleChecked(l.local)}
                                value={l.local}
                                color="primary"
                            />
                            <div className="flex_full_row barlow_regular_smalltext c_cool_grey_two">
                                {l.nlocal}
                            </div>
                        </div>
                    )}
                </DialogContent>
                <DialogActions>
                    <Button onClick={this.handleClose([])} color="primary">
                        <FormattedMessage id="remove" />
                    </Button>
                    <Button onClick={this.handleClose(hide)} color="primary" autoFocus>
                        <FormattedMessage id="accept" />
                    </Button>
                </DialogActions>
            </Dialog>
        );
    }
}

Filter.propTypes = {
    intl: intlShape.isRequired,
};

export default injectIntl(Filter);



// WEBPACK FOOTER //
// ./src/components/complex/reports/employee/FilterMenu.js